// ─── src/hooks/useAwardsNominations.ts ───────────────────────────────────────

import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import {
  deleteAwardsNomination,
  getAwardsNominations,
  getAwardsNominationStats,
  type AwardsNominationParams,
} from "../api/awardsNominations";

export const awardsNominationKeys = {
  all:   ["awardsNominations"] as const,
  list:  (p: AwardsNominationParams) => [...awardsNominationKeys.all, "list", p] as const,
  stats: () => [...awardsNominationKeys.all, "stats"] as const,
};

export const useAwardsNominations = (params: AwardsNominationParams) =>
  useQuery({
    queryKey: awardsNominationKeys.list(params),
    queryFn:  () => getAwardsNominations(params),
    placeholderData: keepPreviousData,
    staleTime: 30_000,
  });

export const useAwardsNominationStats = () =>
  useQuery({
    queryKey: awardsNominationKeys.stats(),
    queryFn: getAwardsNominationStats,
    staleTime: 60_000,
  });

export const useDeleteAwardsNomination = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: deleteAwardsNomination,
    onSuccess: () => qc.invalidateQueries({ queryKey: awardsNominationKeys.all }),
  });
};
